import {
  formatDate,
  getCountDown,
  printCountdownDate,
} from '@betty/toolkit/utils';

export const getLockedLabel = (releaseDate?: string): string => {
  // TODO Move to localization!

  if (releaseDate) {
    const countdown = getCountDown(releaseDate);

    if (countdown.days > 0) {
      return `Play on ${formatDate(releaseDate, 'MMM D')}`;
    }

    if (
      countdown.days === 0 &&
      countdown.hours === 0 &&
      countdown.minutes === 0
    ) {
      return 'Any minute now!';
    }

    return `Play in ${printCountdownDate(countdown)}`;
  }

  return '';
};
